import {useCallback, useEffect, useState} from 'react';
import {
  requestNextAction,
  requestPauseAction,
  requestPlayAction,
  requestPreviousAction,
  requestProgressUpdateAction,
} from '../../machines/playerMachine/playerActions';
import {PlayerMachineContext} from '../../machines/playerMachine/PlayerMachineContext';
import {usePlayerService} from '../MachineProvider/useCurrentService';

export function useControlBarContainer() {
  const playerInterpreter = usePlayerService();
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setPlaying] = useState(false);

  useEffect(() => {
    const subscription = playerInterpreter.subscribe((state) => {
      const context: PlayerMachineContext = state.context;
      setDuration(context.duration || 0);
      setProgress(context.progress || 0);
      setPlaying(playerInterpreter.state.matches('player.playing'));
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [playerInterpreter]);
  const handlePlayPauseClick = useCallback(() => {
    playerInterpreter.send(isPlaying ? requestPauseAction() : requestPlayAction());
  }, [playerInterpreter, isPlaying]);

  const handleNextClick = useCallback(() => {
    playerInterpreter.send(requestNextAction());
  }, [playerInterpreter]);

  const handlePreviousClick = useCallback(() => {
    playerInterpreter.send(requestPreviousAction());
  }, [playerInterpreter]);

  const handleProgressChange = useCallback(
    (newProgress) => {
      playerInterpreter.send(requestProgressUpdateAction(newProgress));
    },
    [playerInterpreter],
  );

  return {
    progress,
    duration,
    isPlaying,
    handlePlayPauseClick,
    handleNextClick,
    handlePreviousClick,
    handleProgressChange,
  };
}
